const schedule = [
  {
    day: 'Thursday, July 30th',
    daySummary: 'Welcome Dinner',
    activities: [
      {
        time: '6:15pm',
        location: "Antico Borgo or Agruturismo L'Infinito",
        description: 'Transportation from hotels to welcome dinner',
      },
      {
        time: '7:00pm-10:00pm',
        location: 'Bistro Uzeta',
        description:
          "Welcome dinner and drinks in Catania! We can't wait to see everyone!",
      },
      {
        time: '10:00pm',
        location: 'Bistro Uzeta to Hotels',
        description: 'Transporation back to your hotels.',
      },
    ],
  },
  {
    day: 'Friday, July 31st',
    daySummary: 'Wedding Day!',
    activities: [
      {
        time: 'Morning-Afternoon:',
        location: 'Wherever you please!',
        description:
          'Breakfast, provided at the hotel. Folks who are not involved in the wedding will have free time before the ceremony. ',
      },
      {
        time: '4pm:',
        location: "Antico Borgo or Agruturismo L'Infinito",
        description:
          'Transportation from your hotels to the winery for the wedding.',
      },
      {
        time: '5pm-1am:',
        location: 'Barone di Villagrande Winery',
        description:
          'Ceremony and wedding festivities. Exact wedding schedule will be provided at the winery. Transporation options will be provided at 11PM or 1AM, depending on what you selected on the surveys we have sent out. Please adhere to your selections.',
      },
    ],
  },
  {
    day: 'Saturday, August 1st',
    daySummary: 'Beach Party Celebration!',
    activities: [
      {
        time: 'Morning',
        location: "Antico Borgo Etneo or Agruturismo L'Infinito",
        description: 'Breakfast, provided at the hotel.',
      },
      {
        time: '11am',
        location: "Antico Borgo Etneo or Agruturismo L'Infinito",
        description: 'Pickup from your hotels to Afrobar Beach Club',
      },
      {
        time: '12pm-5pm',
        location: 'Afrobar Beach Club, Catania',
        description:
          'Beach day!! We will rent out space at a beach club, and have lunch provided there. Transportation options will be at 5pm (from Afrobar) or 1am (from Catania) to return to your hotels, based on what you selected from the surveys we have sent out. Please adhere to your selections.',
      },
      {
        time: '5pm:',
        location: 'Afrobar Beach Club, Catania',
        description: 'Pickup from Afrobar Beach Club, to your hotels.',
      },
      {
        time: '11pm-12:30am:',
        location: 'Afrobar Beach Club Summer DJ Night',
        description:
          'If you have elected to stay in Catania, there will be a Night Party at the club we will be going to. Party on!!',
      },
      {
        time: '1am:',
        location:
          'Giardino Pacini at Via Cardinale Dusmet, 95121 Catania CT, Italy',
        description: 'Pickup from Catania, to your hotels.',
      },
    ],
  },
  {
    day: 'Sunday, August 2nd',
    daySummary: 'Farewell Lunch',
    activities: [
      {
        time: 'Morning',
        location: "Antico Borgo or Agruturismo L'Infinito",
        description: 'Breakfast, provided at the hotel. Checkout is at 11am.',
      },
      {
        time: '11AM',
        location: "Antico Borgo or Agruturismo L'Infinito",
        description: 'Transportation to the luggage drop of facilities.',
      },
      {
        time: '12pm-2pm:',
        location:
          'Mosaik Beer House at 60, Via Musumeci, 95131 Catania CT, Italy',
        description: 'Farewell lunch!',
      },
    ],
  },
];

export default schedule;
